<div *ngIf="obrazPrzedmiotu; else no_image" class="o-flex o-flex--grids pt-4">
  <div class="o-flex__item u-flex-1/3@desktop u-hidden-visually@less-then-wide">
    <img src="{{obrazPrzedmiotu}}" (load)="afterImageLoad()">
  </div>
  <div class="o-flex__item u-flex-2/3@desktop u-flex-1/1@tablet u-flex-1/1@small mt-4">
    <shared-button-group
      [buttons]="lokalizacjeUszkodzen"
      (buttonClick)="wybierzLokalizacje($event.name)"
    ></shared-button-group>
  </div>
</div>

<ng-template #no_image>
  <div class="o-flex__item u-flex-1/1@desktop u-flex-1/1@tablet u-flex-1/1@small mt-4">
    <shared-button-group
      [buttons]="lokalizacjeUszkodzen"
      (buttonClick)="wybierzLokalizacje($event.name)"
    ></shared-button-group>
  </div>
</ng-template>
